<!--
 Copyright 2022 by domX Private Company

 All rights reserved,
 also regarding any disposal, exploitation, reproduction,
 editing, distribution, as well as in the event of
 applications for industrial property rights.

 This software contains proprietary and confidential
 information of domX Private Company.
 The disclosure of confidential information without
 express authorization is prohibited.

 This software may include Open Source Software.
 As far as Open Source Software is included,
 your rights for the respective Open Source Software
 components are governed by the applicable
 Open Source Software licenses.
-->

<template class="fill-height">
  <div >
      <div class="d-flex whitesmoke">
          <v-subheader class="justify-space-between subtitle-1 whitesmoke font-weight-medium grayBold--text">
            {{ $t("graph_history") }}
          </v-subheader>
      </div>
      <HeatingControllerChartView v-if="device.info.device_type == 'DOMX_HC_OT'" :device="device"/>
      <IAQChartView v-else-if="device.info.device_type == 'DOMX_IAQ'" :device="device"/>
      <MBChartView v-else-if="device.info.device_type == 'DOMX_HC_MB'" :device="device"/>
      <SinglePhaseEnergyMeterChartView v-else-if="device.info.device_type == 'SHELLY_EM_1PH'" :device="device"/>
      <ThreePhaseEnergyMeterChartView v-else-if="device.info.device_type == 'SHELLY_EM_3PH'" :device="device"/>
  </div>
</template>


<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import SinglePhaseEnergyMeterChartView from './energy_meter/SinglePhaseEnergyMeterChartView.vue';
import ThreePhaseEnergyMeterChartView from './energy_meter/ThreePhaseEnergyMeterChartView.vue';
import HeatingControllerChartView from './heating_controller_ot/HeatingControllerChartView.vue';
import IAQChartView from './iaq/IAQChartView.vue';
import MBChartView from './heating_controller_mb/MBChartView.vue';
@Component({
  components: {
    HeatingControllerChartView,
    IAQChartView,
    MBChartView,
    SinglePhaseEnergyMeterChartView,
    ThreePhaseEnergyMeterChartView
  }
})
export default class DevicesSideviewChartsTab extends Vue {
 @Prop() device: Record<string, any>;

}
</script>

<style scoped lang="scss">
.tab {
  max-height: calc(80vh) !important;
  overflow-y: auto;
}

div { 
    width:100%;
}

.expansion-item {
  display: block;
  width: 50px;
  word-wrap: break-word;
}

.is_disabled {
  color: #b9b9b9!important;
  background-color:#e6e6e6;

}
</style>
